// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ModelSearch from "./model-search.js"
import ModelSearchRule from "./model-search-rule.js"

const modelClassData = {
  "attributes": {
    "group_mode": {
      "column": {
        "default": null,
        "name": "group_mode",
        "null": false,
        "type": "string"
      },
      "name": "group_mode",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ModelSearchGroup",
  "collectionKey": "model_search_groups",
  "collectionName": "model_search_groups",
  "i18nKey": "model_search_group",
  "camelizedLower": "modelSearchGroup",
  "name": "ModelSearchGroup",
  "nameDasherized": "model-search-group",
  "pluralName": "model_search_groups",
  "ransackable_associations": [
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "ModelSearchGroup",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ModelSearch",
      "collectionName": "model_searches",
      "foreignKey": "model_search_id",
      "name": "model_search",
      "macro": "belongs_to",
      "resource_name": "ModelSearch",
      "through": null
    },
    {
      "className": "ModelSearchRule",
      "collectionName": "model_search_rules",
      "foreignKey": "model_search_group_id",
      "name": "model_search_rules",
      "macro": "has_many",
      "resource_name": "ModelSearchRule",
      "through": null
    },
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "ModelSearchGroup",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "children_count",
      "column": {
        "default": 0,
        "name": "children_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "depth",
      "column": {
        "default": 0,
        "name": "depth",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "group_mode",
      "column": {
        "default": null,
        "name": "group_mode",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "lft",
      "column": {
        "default": null,
        "name": "lft",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "model_search_id",
      "column": {
        "default": null,
        "name": "model_search_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_model_search_id",
      "column": {
        "default": null,
        "name": "old_model_search_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_parent_id",
      "column": {
        "default": null,
        "name": "old_parent_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "parent_id",
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "rgt",
      "column": {
        "default": null,
        "name": "rgt",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "ModelSearchGroup",
      "through": null
    },
    {
      "className": "ModelSearch",
      "collectionName": "model_searches",
      "foreignKey": "model_search_id",
      "name": "model_search",
      "macro": "belongs_to",
      "resource_name": "ModelSearch",
      "through": null
    },
    {
      "className": "ModelSearchRule",
      "collectionName": "model_search_rules",
      "foreignKey": "model_search_group_id",
      "name": "model_search_rules",
      "macro": "has_many",
      "resource_name": "ModelSearchRule",
      "through": null
    },
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "ModelSearchGroup",
      "through": null
    }
  ],
  "paramKey": "model_search_group",
  "primaryKey": "id"
}

/** Frontend model for ModelSearchGroup. */
export default class ModelSearchGroup extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  groupMode() {
    return this.readAttributeUnderscore("group_mode")
  }

  /** @returns {boolean} */
  hasGroupMode() {
    const value = this.groupMode()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./model-search-group.js").default>} */
  children() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "children",
        model: this,
        modelClass: ModelSearchGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./model-search-group.js").default>>} */
  loadChildren() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "children",
        model: this,
        modelClass: ModelSearchGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./model-search-group.js").default>>} */
  ensureChildrenLoaded() {
    return this.ensureAssociationLoaded("children")
  }

  /** @returns {import("./model-search.js").default | null} */
  modelSearch() {
    return this._readBelongsToReflection({modelClass: ModelSearch, reflectionName: "model_search"})
  }

  /** @returns {Promise<import("./model-search.js").default | null>} */
  loadModelSearch() {
    if (!("modelSearchId" in this)) throw new Error("Foreign key method wasn't defined: modelSearchId")

    const id = this.modelSearchId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "model_search",
        model: this,
        modelClass: ModelSearch
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./model-search.js").default | null>} */
  ensureModelSearchLoaded() {
    return this.ensureAssociationLoaded("model_search")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./model-search-rule.js").default>} */
  modelSearchRules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["model_search_group_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "model_search_rules",
        model: this,
        modelClass: ModelSearchRule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./model-search-rule.js").default>>} */
  loadModelSearchRules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["model_search_group_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "model_search_rules",
        model: this,
        modelClass: ModelSearchRule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./model-search-rule.js").default>>} */
  ensureModelSearchRulesLoaded() {
    return this.ensureAssociationLoaded("model_search_rules")
  }

  /** @returns {import("./model-search-group.js").default | null} */
  parent() {
    return this._readBelongsToReflection({modelClass: ModelSearchGroup, reflectionName: "parent"})
  }

  /** @returns {Promise<import("./model-search-group.js").default | null>} */
  loadParent() {
    if (!("parentId" in this)) throw new Error("Foreign key method wasn't defined: parentId")

    const id = this.parentId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "parent",
        model: this,
        modelClass: ModelSearchGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./model-search-group.js").default | null>} */
  ensureParentLoaded() {
    return this.ensureAssociationLoaded("parent")
  }
}
